import { useSearchParams } from "react-router-dom";
import { GenieOwnerDetail, type OwnerTab } from "@/components/voice-genie/GenieOwnerDetail";
import AnalysisTab from "./tabs/AnalysisTab";
import ConversationsTab from "./tabs/ConversationsTab";
import KnowledgeTab from "./tabs/KnowledgeTab";
import OverviewTab from "./tabs/OverviewTab";

const VALID_TABS: OwnerTab[] = ["overview", "conversations", "analysis", "knowledge"];

/**
 * /genies/:id — immersive read-only genie detail (viewer direction).
 * One route, in-page tabs via `?tab=` (default "overview"). The shared
 * GenieOwnerDetail provides the chrome; this picks the active tab body.
 */
const GenieOwnerPage = () => {
  const [searchParams] = useSearchParams();
  const tabParam = (searchParams.get("tab") as OwnerTab | null) ?? "overview";
  const active: OwnerTab = VALID_TABS.includes(tabParam) ? tabParam : "overview";

  const body =
    active === "conversations" ? (
      <ConversationsTab />
    ) : active === "analysis" ? (
      <AnalysisTab />
    ) : active === "knowledge" ? (
      <KnowledgeTab />
    ) : (
      <OverviewTab />
    );

  return <GenieOwnerDetail active={active}>{body}</GenieOwnerDetail>;
};

export default GenieOwnerPage;
